<template>
  <div>
    <div v-if="passwordSent">
      {{loc('components.forgottenPassword.passwordSent')}}
    </div>
    <div v-else>
      <v-form :fields="fields" :form-data="formData" :form-errors="formErrors">
        <div slot="buttons">
          <button :disabled="sendDisabled" type="submit" v-on:click="send" class="btn btn--white">{{loc('orderNewPassword')}}</button>
        </div>
      </v-form>

    </div>
  </div>
</template>

<script>

import VForm from './v-form.vue';

export default {
  components: {
    'v-form': VForm
  },
  name: 'ViewForgotPassword',
  data: function () {
    return {
      formErrors: {},
      formData: {},
      passwordSent: false,
      token: null,
      sendDisabled: false
    }
  },
  computed: {
    fields() {
      return [{
        name: 'token',
        value: '',
        label: this.loc('token'),
        type: 'hidden'
      }, {
        name: 'username',
        value: '',
        label: this.loc('username'),
        type: 'text'
      }];
    },
  },
  methods: {
    async send() {
      const self = this;

      this.sendDisabled = true;

      if(!this.token) {
        const tokenRes = await this.$api.getToken();
        if(tokenRes.code === 200) {
          this.token = tokenRes.result.token;
        }
      }

      return this.$api.forgotPassword({
        token: this.token,
        username: this.formData.username
      })
      .then(res => {
        this.sendDisabled = false;
        this.token = '';

        // Errors in form
        if(res.code === 400) {
          this.formErrors = res.result.fields;
        }

        if(res.code === 200) {
          this.passwordSent = true;
        }
      });
    }
  },
  mounted: function () {
    this.$api.getToken().then(res => {
      if(res.code === 200) {
        this.token = res.result.token;
      }
    });
    this.$store.commit('setSubheader', {
      subtitle: '',
      title: this.loc('components.forgottenPassword.subheaderTitle'),
      description: '',
      searchEnabled: false
    });
  }
}
</script>
